import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StepService } from 'services/professional/step/step.service';
import { StepInstance } from 'services/professional/step/step.interface';
import { STEP_TYPES } from 'constants/status.constants';
import { WORKFLOW_MODULE_ID } from 'constants/workflow.constants';
import { CertificationStepAdditionalData } from 'pages/organization/testing-workflow/workflow.interface';

@Component({
  selector: 'cm-step-details-modal',
  templateUrl: './step-details.modal.component.html',
  styleUrls: ['./step-details.modal.component.scss'],
})
export class StepDetailsModalComponent {
  WORKFLOW_MODULE_ID = WORKFLOW_MODULE_ID;
  @Input() certificate;
  @Input() closeModal;
  @Input() additionalData: CertificationStepAdditionalData;
  @Input() initialStepData: StepInstance;
  @Input() workflowTypeId: number;
  isFullMode = true;
  readonly STEP_TYPES = STEP_TYPES;

  constructor(public activeModal: NgbActiveModal, private stepService: StepService) {}

  onModeToggle(mode?: boolean): void {
    // temp handler
    if (mode !== undefined) {
      this.isFullMode = mode;
    } else {
      this.isFullMode = !this.isFullMode;
    }
  }

  updateStep() {
    this.stepService
      .getCertificateStep(this.initialStepData.step_instance_id)
      .subscribe((res) => (this.initialStepData = res));
  }
}
